// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.locations.RentalManagerUserPropertyLocationRestrictionsWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { ListingAlias, ListingType, PropertyType, UserPropertyLocationRestrictionsResponseWebDto } from '../..';

interface RestrictionsParams {
  fullAddress: string;
  listingAlias?: ListingAlias;
  listingType: ListingType;
  propertyType?: PropertyType;
  unit?: string;
}

export const RentalManagerUserPropertyLocationRestrictionsWebApiHandler_restrictions_Path =
  '/api/web/v1/users/properties/locations/restrictions';

/**
 * Get location restrictions for a property by address and listing type
 */
export const RentalManagerUserPropertyLocationRestrictionsWebApiHandler_restrictions = (
  getParams: RestrictionsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<RestrictionsParams, never, UserPropertyLocationRestrictionsResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyLocationRestrictionsWebApiHandler_restrictions_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
